// CustomRenderFields.jsx
import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import RenderFields from "../../../../../../components/Modals/ModalFields/RenderFields";
import { selectAllCompanies } from "../../../../../../redux/mgmtCo/managementSlice";

const RenderFieldsCustomers = (props) => {
  const {
    fields,
    formData,
    handleChange,
    fieldTransformers = {},
    dropdownLists,
    ...rest
  } = props;
  const managementCompanies = useSelector(selectAllCompanies);

  const modifiedFields = fields.map((field) => {
    if (field.key === "managementID") {
      return {
        ...field,
        forceReadOnly: true, // Always read-only for managementID
      };
    }
    if (field.key === "paymentID") {
      return {
        ...field,
        // Map allPaymentTerms from dropdownLists to options
        options: (Array.isArray(dropdownLists?.allPaymentTerms)
          ? dropdownLists.allPaymentTerms
          : []
        ).map((term) => ({ value: term.id, label: term.name })),
      };
    }
    if (field.key === "taxDetailID") {
      return {
        ...field,
        // Map allTaxDetails from dropdownLists to options
        options: (Array.isArray(dropdownLists?.allTaxDetails)
          ? dropdownLists.allTaxDetails
          : []
        ).map((detail) => ({
          value: detail.id,
          label: detail.description,
        })),
      };
    }
    if (field.key === "salesID") {
      return {
        ...field,
        // Map allSalesPersons from dropdownLists to options
        options: (Array.isArray(dropdownLists?.allSalesPersons)
          ? dropdownLists.allSalesPersons
          : []
        ).map((person) => ({
          value: person.id,
          label: person.firstName + " " + person.lastName,
        })),
      };
    }
    return field;
  });

  // Build a custom transformer to display the company name instead of the ID.
  const customFieldTransformers = {
    ...fieldTransformers,
    managementID: (value) => {
      const company = managementCompanies.find(
        (comp) => comp.managementId === value
      );
      return company ? company.companyName : "-";
    },
  };

  return (
    <RenderFields
      fields={modifiedFields}
      formData={formData}
      handleChange={handleChange}
      // The overall readOnly value is still passed in,
      // but managementID will always use its own override.
      fieldTransformers={customFieldTransformers}
      {...rest}
    />
  );
};

RenderFieldsCustomers.propTypes = {
  fields: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  fieldTransformers: PropTypes.object,
};

export default RenderFieldsCustomers;
